import { Component } from 'preact';

export default class Portal extends Component {
	shouldComponentUpdate() {
		if (typeof this.props.shouldComponentUpdate === 'function') {
			return this.props.shouldComponentUpdate();
		}

		return false;
	}

	render() {
		const { children, className, id } = this.props;

		return (
			<div id={id || className} className={className}>
				{children}
			</div>
		);
	}
}
